import columns from './utils/columns'
import summaries from './utils/summaries'

const state = () => ({
  reportId: null,
  reportName: 'yield',
  subId: null,

  publisher: null,

  health: null,
  yield: null,
  programmatic: null,

  columns,
  summaries,

  programmaticViewStatus: null,
  isLoadingProgrammatic: false,
  didLoadProgrammaticFail: false,

  isLoadingPublisher: false,
  didLoadPublisherFail: false,
})

export default state
